import React from "react"
import { Box, Button, Stack, Typography } from "@mui/material"
import { useState } from "react"
import { COLORS } from "../../../utils"

const sx = {
  value: {
    fontSize: 18,
    fontWeight: 400,
    color: "#262626",
    lineHeight: 1.5
	},
  button: {
    padding: 0,
    color: COLORS.PRODUCTION_RECEPTION_COLOR,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1,
  },
}

const MergedPSEHeaderInfos = ({ type = "recipes", mergedProductionStepExecutions = [] }) => {
  const [open, setOpen] = useState(false)

  const toggleOpen = () => setOpen(!open)

  return (
    <Stack spacing={1}>
      <Typography>
        {mergedProductionStepExecutions.length} {type === "recipes" ? "recettes" : "sections"}
      </Typography>
      {open
        ? (
          <Stack spacing={2}>
            <Stack spacing={1}>
              {mergedProductionStepExecutions.map((merged, index) => (
                <Stack
                  key={merged.objectId + index}
                  direction="row"
                  alignItems="center"
                  spacing={1}
                  sx={{ pl: 1 }}
                >
                  <Box sx={{ width: 4, height: 4, borderRadius: "50%", bgcolor: "#000"}} />
                  {type === "recipes" && (
                    <>
                      <Typography sx={sx.value}>{merged.uniqueCode} - {merged.recipeName}</Typography>
                    </>
                  )}
                  {type === "sections" && (
                    <Typography sx={sx.value}>{merged.sectionName}</Typography>
                  )}
                </Stack>
              ))}
            </Stack>
          <div>
            <Button sx={sx.button} onClick={toggleOpen}>
                Voir Moins
            </Button>
          </div>
          </Stack>
        ) : (
          <div>
            <Button sx={sx.button} onClick={toggleOpen}>
              Voir Plus
            </Button>
          </div>
        )
      }
    </Stack>
  )
}

export default MergedPSEHeaderInfos